import React from "react";
import { Link } from "react-router-dom";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useMutation } from "@tanstack/react-query";

import useAuthService from "../../../services/api/authService";
import { CONFIGURATION, enums } from "../../../constants/enum";
import { loginValidationSchema } from "../../../schemas/auth";
import { fetchUser } from "../../../store/slices/authSlice";

import { Button } from "../../../components";
import { PasswordInput, TextInput } from "../../../components/forms";

import "./LoginPage.scss";

function LoginPage() {
  const { login } = useAuthService();
  const mutation = useMutation({
    mutationFn: login,
  });
  const dispatch = useDispatch();
  const initialValues = {
    username: "",
    password: "",
  };
  const handleLogin = async (values) => {
    mutation.mutate(
      { payload: values },
      {
        onSuccess: (data) => {
          localStorage.setItem(
            CONFIGURATION.REFRESH_TOKEN_KEY,
            data.payload?.refreshToken,
          );
          dispatch(fetchUser(data.payload?.accessToken));
        },
        onError: (error) => {
          toast.error(
            error.response.data.payload?.message || enums.DEFAULT_ERROR_MESSAGE,
          );
        },
      },
    );
  };

  return (
    <div className="login-page">
      <div className="login-bg"></div>

      <div className="login-wrapper">
        <div className="login-card">
          <div className="title">
            <h1>Shop Login</h1>
            <p>Hey, enter your details to get sign in to your account.</p>
          </div>

          <div className="login-form">
            <Formik
              initialValues={initialValues}
              validationSchema={loginValidationSchema}
              onSubmit={handleLogin}
            >
              <Form>
                <TextInput
                  className="login-input"
                  name="username"
                  placeholder="Enter username"
                  autoFocus={true}
                />
                <PasswordInput
                  className="login-input"
                  name="password"
                  placeholder="Enter password"
                />
                <Button type="submit" text="Sign in" />
              </Form>
            </Formik>
          </div>

          <div className="login-message">
            <p>Having trouble signing in?</p>
            <p>Please contact us using the phone numbers below.</p>
            <p>
              <Link to="tel:0761205789">0761205789</Link>{" "}
              {/* <Link to="tel:0712345678">0712345678</Link> /{" "} */}
              {/* <Link to="tel:0712345678">0712345678</Link> */}
            </p>
          </div>
        </div>

        <div className="copyright">
          <p>- Copyright &copy; Saroja Opticians design and development by <b><Link to="https://invidiar.com" target="_blank">INVIDIAR</Link></b> -</p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
